<ng-template #teacherPopover
  >Assign displays to your teachers allowing them to manage their content in a
  simple interface.
  <a
    class="madero-link u_clickable"
    href="#"
    (click)="
      helpWidgetService.openArticle(
        '522',
        'https://help.risevision.com/hc/en-us/articles/8181799293204-How-do-teachers-create-content-'
      )
    "
    >More details</a
  >
</ng-template>
<div
  class="tw-full tw-flex tw-flex-col xl:!tw-flex-row tw-justify-evenly tw-gap-8"
>
  <div
    class="tw-full xl:!tw-w-4/6 tw-bg-white tw-rounded-xl tw-p-12 tw-shadow-sm"
  >
    <div *ngIf="user && user.username">
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-mb-8 tw-border-solid tw-border-0 tw-border-b tw-border-gray-200 tw-pb-8"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
          <div class="tw-flex tw-items-center">
            <ng-container *ngIf="user.avatarUrl; else noAvatar">
              <img
                [src]="user.avatarUrl"
                alt="User avatar"
                class="tw-w-20 tw-h-20 tw-rounded-full tw-object-cover tw-mr-6"
              />
            </ng-container>
            <ng-template #noAvatar>
              <div class="tw-mr-6">
                <initials-badge
                  [name]="user.firstName + ' ' + user.lastName"
                  [size]="48"
                ></initials-badge>
              </div>
            </ng-template>
            <div>
              <div class="tw-font-bold tw-text-3xl">
                {{ user.firstName }} {{ user.lastName }}
              </div>
              <div
                id="user-settings-email-label"
                class="tw-text-gray-500 tw-text-2xl"
              >
                {{ user.email }}
              </div>
            </div>
          </div>
          <div>
            <button
              id="moreSettingsButton"
              type="button"
              class="dropdown-toggle tw-flex tw-items-center tw-justify-center tw-ml-2 tw-rounded-full tw-p-2 tw-border tw-border-solid tw-border-gray-200 tw-bg-transparent focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
              [matMenuTriggerFor]="menu"
              aria-label="More options"
            >
              <mat-icon svgIcon="more-vertical" class="tw-rotate-90" />
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="showChangePassword = !showChangePassword"
                [attr.aria-expanded]="showChangePassword"
                aria-controls="change-password-content"
                aria-label="Change Password"
              >
                <mat-icon svgIcon="edit" class="small"></mat-icon>
                <span>Change Password</span>
              </button>
              @for (action of actions.moreOptions; track action.id) {
                @if (!action.disabled && action.id !== 'changePasswordButton') {
                  <button
                    mat-menu-item
                    [id]="action.id"
                    *requireRole="action.requireRole"
                    (click)="action.action()"
                    (keyup.enter)="action.action()"
                    [class.rise-admin-only]="action.requireRole === 'sa'"
                  >
                    @if (action.icon) {
                      <mat-icon
                        [svgIcon]="action.icon"
                        class="small tw-mr-2"
                      ></mat-icon>
                    }
                    {{ action.label }}
                  </button>
                }
              }
              @if (actions.deleteAction && !actions.deleteAction.disabled) {
                <div
                  class="tw-border-solid tw-border-0 tw-border-t tw-border-gray-200 tw-pt-1 tw-mt-2"
                >
                  <button
                    class="tw-text-red-700"
                    mat-menu-item
                    [id]="actions.deleteAction.id"
                    *requireRole="actions.deleteAction.requireRole"
                    [class.rise-admin-only]="
                      actions.deleteAction.requireRole === 'sa'
                    "
                    (click)="actions.deleteAction.action()"
                  >
                    @if (actions.deleteAction.icon) {
                      <mat-icon
                        [svgIcon]="actions.deleteAction.icon"
                        class="small tw-mr-2"
                      ></mat-icon>
                    }
                    {{ actions.deleteAction.label }}
                  </button>
                </div>
              }
            </mat-menu>
          </div>
        </div>
        @if (showChangePassword && isRiseAuthUser) {
          <div
            id="change-password-content"
            class="tw-flex tw-w-full tw-gap-8 tw-mt-8"
          >
            <div class="tw-flex-1">
              <label
                for="user-settings-current-password"
                class="tw-font-medium tw-mb-2"
                >Current Password</label
              >
              <input
                id="user-settings-current-password"
                type="password"
                class="form-control tw-rounded-lg tw-rounded tw-border tw-border-gray-300 tw-bg-white"
                [(ngModel)]="userPassword.currentPassword"
                name="currentPassword"
                autocomplete="current-password"
                aria-label="Current Password"
                required
              />
            </div>
            <div class="tw-flex-1">
              <label
                for="user-settings-new-password"
                class="tw-font-medium tw-mb-2"
                >New Password</label
              >
              <input
                id="user-settings-new-password"
                type="password"
                class="form-control tw-rounded-lg tw-rounded tw-border tw-border-gray-300 tw-bg-white"
                [(ngModel)]="userPassword.newPassword"
                name="newPassword"
                autocomplete="new-password"
                aria-label="New Password"
                required
              />
            </div>
          </div>
        }

        @if (user.ssouserProvisioningEnabled) {
          <notification-alert
            class="tw-w-full tw-mt-8"
            title="SSO Provisioning Enabled"
            message="Some user settings are disabled and must be managed in your IdP portal."
          />
        }

        @if (editingYourself) {
          <div
            id="passwordAlert"
            class="animated tw-w-full tw-mt-8"
            [shown]="!isRiseAuthUser && showChangePassword"
            [ngClass]="{ fadeIn: showChangePassword }"
          >
            <div class="panel-body bg-info u_margin-sm-bottom tw-rounded-lg">
              <p class="u_remove-bottom">
                <span
                  >This account is authenticated by Google.<br />
                  <a
                    href="https://myaccount.google.com/security#signin"
                    rel="noopener noreferrer"
                    target="_blank"
                    >Change your password on your Google account.</a
                  >
                </span>
              </p>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="tw-flex tw-items-center tw-mb-8">
      <h2 class="tw-text-[16px] tw-mt-0 tw-font-bold tw-flex-1">Account</h2>
      @if (user.lastLogin) {
        <div class="tw-text-right tw-text-gray-500 tw-text-2xl">
          Last active: {{ user.lastLogin | date: 'dd MMM yyyy hh:mm a' }}
        </div>
      }
    </div>

    <form>
      <div class="tw-grid tw-grid-cols-1 xl:!tw-grid-cols-2 tw-gap-6">
        <div class="form-group">
          <label for="user-settings-username" class="tw-font-medium tw-mb-2"
            >Username{{ isAddMode ? ' *' : '' }}</label
          >
          <input
            #username="ngModel"
            id="user-settings-username"
            type="email"
            required
            name="username"
            autocomplete="off"
            class="form-control tw-rounded-lg tw-rounded tw-border tw-border-gray-300"
            [ngClass]="{ 'tw-bg-gray-100': !isAddMode }"
            [(ngModel)]="editUser.username"
            [pattern]="EMAIL_REGEX"
            [disabled]="!isAddMode"
          />
          <p
            [shown]="
              username.invalid && (!username.pristine || userForm.submitted)
            "
            class="help-block validation-error-message-email tw-text-red-600"
          >
            User name must be a valid email address.
          </p>
        </div>
        <div class="form-group">
          <label for="company-role" class="tw-font-medium tw-mb-2"
            >Company Role</label
          >
          <select
            name="companyRole"
            id="company-role"
            class="form-control selectpicker tw-rounded-lg tw-rounded tw-border tw-border-gray-300"
            [(ngModel)]="editUser.companyRole"
          >
            <option value="" [shown]="false">&lt; Select Role &gt;</option>
            @for (role of COMPANY_ROLE_FIELDS; track role) {
              <option value="{{ role[1] }}">{{ role[0] }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label for="user-settings-first-name" class="tw-font-medium tw-mb-2"
            >First name{{ isAddMode ? ' *' : '' }}</label
          >
          <input
            #firstName="ngModel"
            id="user-settings-first-name"
            type="text"
            required
            name="firstName"
            autocomplete="off"
            class="form-control tw-rounded-lg tw-rounded tw-border tw-border-gray-300"
            [(ngModel)]="editUser.firstName"
            [disabled]="user.ssouserProvisioningEnabled"
          />
          <p
            [shown]="
              firstName.invalid && (!firstName.pristine || userForm.submitted)
            "
            class="help-block validation-error-message-firstName tw-text-red-600"
          >
            First name is required.
          </p>
        </div>
        <div class="form-group">
          <label for="user-settings-last-name" class="tw-font-medium tw-mb-2"
            >Last name{{ isAddMode ? ' *' : '' }}</label
          >
          <input
            #lastName="ngModel"
            id="user-settings-last-name"
            type="text"
            required
            name="lastName"
            autocomplete="off"
            class="form-control tw-rounded-lg tw-rounded tw-border tw-border-gray-300"
            [(ngModel)]="editUser.lastName"
            [disabled]="user.ssouserProvisioningEnabled"
          />
          <p
            [shown]="
              lastName.invalid && (!lastName.pristine || userForm.submitted)
            "
            class="help-block validation-error-message-lastName tw-text-red-600"
          >
            Last name is required.
          </p>
        </div>
        <div class="form-group">
          <label for="user-settings-phone" class="tw-font-medium tw-mb-2"
            >Phone number</label
          >
          <input
            id="user-settings-phone"
            type="tel"
            name="phone"
            autocomplete="off"
            class="form-control tw-rounded-lg tw-rounded tw-border tw-border-gray-300"
            [(ngModel)]="editUser.telephone"
          />
        </div>
        <div class="form-group">
          <label for="user-settings-email" class="tw-font-medium tw-mb-2"
            >Work email{{ isAddMode ? ' *' : '' }}</label
          >
          <input
            #email="ngModel"
            id="user-settings-email"
            type="email"
            required
            name="email"
            autocomplete="off"
            class="form-control tw-rounded-lg tw-rounded tw-border tw-border-gray-300"
            [(ngModel)]="editUser.email"
            [pattern]="EMAIL_REGEX"
            [disabled]="user.ssouserProvisioningEnabled"
          />
          <p
            [shown]="email.invalid && (!email.pristine || userForm.submitted)"
            class="help-block validation-error-message-email tw-text-red-600"
          >
            A valid email address is required. Please enter an email in the
            format: example&#64;domain.com
          </p>
        </div>
        @if (
          editUser.settings && companyAccessService.isEnterpriseOrUnlimited
        ) {
          <div class="form-group" *requireRole="'ua'">
            <mat-slide-toggle
              id="user-settings-ai-enabled"
              name="aiEnabled"
              [(ngModel)]="editUser.settings.aiEnabled"
            >
              <span class="tw-font-medium tw-text-[14px]"> Enable AI </span>
            </mat-slide-toggle>
          </div>
        }
      </div>
    </form>
  </div>
  <div
    class="tw-full xl:!tw-w-2/6 tw-bg-white tw-rounded-xl tw-p-12 tw-shadow-sm"
    *requireRole="'!ap'"
  >
    <div class="tw-mb-4">
      <div class="tw-font-bold tw-text-3xl">Roles</div>
      <div class="tw-text-gray-600 tw-mt-2 tw-mb-4">
        User roles can be assigned to each User. Each role enables a User to
        access different functions of Rise Vision. To learn more read
        <a
          href="https://help.risevision.com/hc/en-us/articles/115000882303-Users-and-Roles-Overview"
          target="_blank"
          rel="noopener noreferrer"
          class="tw-text-blue-600 tw-underline"
          >this article.</a
        >
      </div>
    </div>
    <div class="tw-mt-8">
      <div *ngFor="let role of USER_ROLES; let last = last">
        <div
          *ngIf="editRoleVisible(role)"
          class="tw-flex tw-items-center tw-justify-between tw-py-3"
          [ngClass]="{
            'tw-border-solid tw-border-0 tw-border-b tw-border-gray-200': !last,
          }"
        >
          <div class="tw-flex tw-items-center">
            <mat-checkbox
              id="checkbox-user-role-{{ role.key }}"
              name="checkbox-user-role-{{ role.key }}"
              [checked]="editUser.roles?.includes(role.key)"
              (change)="onCheckboxChange(role)"
              aria-labelledby="label-user-role-{{ role.key }}"
              [disabled]="
                !editRoleAllowed(role) || user.ssouserProvisioningEnabled
              "
            >
              <span
                class="tw-font-medium tw-text-[14px]"
                [ngClass]="{ 'rise-admin-only': role.admin }"
                >{{ role.value }}</span
              >
            </mat-checkbox>
          </div>
          <div class="tw-flex tw-items-center">
            @if (role.key === 'ap') {
              <mat-icon
                svgIcon="help"
                aria-label="More information"
                class="help tw-ml-2 tw-text-gray-400 hover:tw-text-gray-600"
                [outsideClick]="true"
                triggers="click"
                [popover]="teacherPopover"
              >
              </mat-icon>
            }
            @if (role.key === 'ap' && !teacherRoleAvailable) {
              <upgrade-notice
                #UpgradeNotice
                feature="teacher_role"
                class="tw-ml-2 tw-pt-2"
              ></upgrade-notice>
            }
            @if (role.key === 'sm' && !screenSharingAvailable) {
              <upgrade-notice
                #UpgradeNotice
                feature="screen_sharing"
                class="tw-ml-2 tw-pt-2"
              ></upgrade-notice>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (!editingYourself && !isAddMode) {
  <div class="form-group" [shown]="!editingYourself" *requireRole="'sa'">
    <div class="tw-mt-8 xl:!tw-mt-24">
      <div class="tw-flex tw-items-center tw-mb-2 tw-w-full tw-justify-between">
        <p class="tw-mb-0 tw-mr-2 rise-admin-only">
          <strong
            class="tw-cursor-pointer"
            (click)="toggleActivationLinkVisibility()"
            >Activation Link</strong
          >
        </p>
        <div class="tw-flex tw-items-center">
          <button
            type="button"
            class="tw-bg-transparent tw-border-0 tw-cursor-pointer"
            (click)="toggleActivationLinkVisibility()"
          >
            <span class="tw-cursor-pointer">{{
              showActivationLink ? 'Hide' : 'Show'
            }}</span>
          </button>
          <mat-icon
            svgIcon="chevron-down"
            class="tw-cursor-pointer tw-text-gray-500 hover:tw-text-gray-700"
            [ngClass]="{ 'tw-rotate-180': showActivationLink }"
            (click)="toggleActivationLinkVisibility()"
          ></mat-icon>
        </div>
      </div>
      <div *ngIf="showActivationLink" class="tw-relative tw-w-full">
        <input
          readonly
          #activationLinkText
          class="form-control tw-w-full tw-pr-12 tw-truncate tw-bg-gray-50 tw-border-0 xl:!tw-mt-6"
          [value]="activationLink"
        />
        <mat-icon
          svgIcon="copy"
          aria-label="Copy Activation Link"
          class="tw-cursor-pointer tw-absolute tw-right-2 tw-top-1/2 tw--translate-y-1/2 tw-text-gray-500 hover:tw-text-gray-700"
          (click)="copyActivationLink(activationLinkText.value)"
        ></mat-icon>
      </div>
    </div>
  </div>
}
